module.exports = __webpack_public_path__ + "static/media/user-placeholder-gender-three.970ef8a3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user-placeholder-gender-three.webp
// module id = 385
// module chunks = 31